import { LanguageActionsService } from './languages.actions';
import { SettingActionsService } from './setting.actions';

export { LanguageActionsService, SettingActionsService };

export const list = [LanguageActionsService, SettingActionsService];
